/* new id — Elafia Tribe theme scripts. No dependencies. */
(function () {
  'use strict';

  var E = window.Elafia || {};
  var S = E.strings || {};
  var root = (E.root || '/').replace(/\/?$/, '/');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    var n = Math.round(cents / 100).toLocaleString('en-US');
    return n + ' ' + (S.currency || 'EGP');
  }

  /* ---------- Header search ---------- */
  function initSearch() {
    var btn = $('[data-search-toggle]');
    var panel = $('#HeaderSearch');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) { var i = $('input[type=search]', panel); if (i) i.focus(); }
    });
  }

  /* ---------- Product range: hair-type tabs ---------- */
  function initRanges() {
    $$('[data-range]').forEach(function (range) {
      var tabs = $$('[data-filter]', range);
      var cards = $$('[data-hair]', range);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var f = tab.getAttribute('data-filter');
          tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === tab)); });
          cards.forEach(function (c) {
            var hair = (c.getAttribute('data-hair') || '').split(' ');
            c.hidden = !(f === 'all' || hair.indexOf(f) !== -1 || hair.indexOf('all') !== -1);
          });
        });
      });
    });
  }

  /* ---------- Bundle builder (homepage + product page) ----------
     Same rules as Octo Ash: 2 items -> d2% off the cheapest, 3 items -> d3% off the cheapest.
     The real discounts are Shopify automatic discounts; this is only a preview. */
  function initBundles() {
    var d2 = (E.offer && E.offer.d2 || 0) / 100;
    var d3 = (E.offer && E.offer.d3 || 0) / 100;
    var freeShip = (E.offer && E.offer.freeShip) || 0;

    $$('[data-bundle]').forEach(function (box) {
      if (box.__ready) return; box.__ready = true;
      var tiers = $$('[data-tier]', box);
      var selected = parseInt(box.getAttribute('data-default'), 10) || 2;

      function slotsOf(tier) {
        var k = tier.getAttribute('data-tier');
        return $('[data-slots-for="' + k + '"]', box) || tier;
      }
      function picks(tier) {
        return $$('select[data-pick]', slotsOf(tier)).map(function (s) {
          var o = s.options[s.selectedIndex];
          return { id: s.value, price: parseInt(o && o.getAttribute('data-price'), 10) || 0 };
        });
      }
      function calc(tier) {
        var items = picks(tier), sum = 0, min = Infinity;
        items.forEach(function (i) { sum += i.price; if (i.price < min) min = i.price; });
        var n = items.length, off = 0;
        if (n === 2) off = min * d2; else if (n >= 3) off = min * d3;
        var total = sum - off;
        return { items: items, sum: sum, off: off, total: total, ship: freeShip > 0 && total >= freeShip };
      }
      function render() {
        var results = {};
        tiers.forEach(function (t) {
          var k = parseInt(t.getAttribute('data-tier'), 10);
          var r = calc(t); results[k] = r;
          var now = $('[data-now]', t), was = $('[data-was]', t);
          if (now) now.textContent = money(r.total);
          if (was) was.textContent = r.off > 0 ? money(r.sum) : '';
          var on = k === selected;
          t.classList.toggle('is-selected', on);
          var btn = t.matches('button') ? t : $('[data-tier-select]', t);
          if (btn) btn.setAttribute('aria-pressed', String(on));
        });
        $$('[data-slots-for]', box).forEach(function (g) { g.hidden = parseInt(g.getAttribute('data-slots-for'), 10) !== selected; });
        var cur = results[selected];
        if (!cur) return;
        $$('[data-total]', box).forEach(function (el) { el.textContent = Math.round(cur.total / 100).toLocaleString('en-US'); });
        $$('[data-cta-price]', box).forEach(function (el) { el.textContent = money(cur.total); });
        var saved = $('[data-saved]', box);
        if (saved) saved.textContent = cur.off > 0 ? (S.save || '').replace('[amount]', money(cur.off)) + (cur.ship ? ' + ' + (S.freeShipping || '') : '') : '';
        var fill = $('[data-progress]', box);
        if (fill) fill.style.width = Math.min(100, Math.round(selected / 3 * 100)) + '%';
        var label = $('[data-qty-label]', box);
        var tierEl = tiers[selected - 1];
        if (label && tierEl) label.textContent = tierEl.getAttribute('data-label') || '';
        var nudge = $('[data-nudge]', box), nudgeText = $('[data-nudge-text]', box);
        if (nudge) {
          var next = results[selected + 1];
          if (next) {
            var tpl = selected === 1 ? S.nudge2 : S.nudge3;
            if (nudgeText) nudgeText.textContent = (tpl || '').replace('[amount]', money(next.off));
            nudge.hidden = false;
            nudge.setAttribute('data-done', 'false');
          } else if (nudge.hasAttribute('data-show-done')) {
            if (nudgeText) nudgeText.textContent = S.done || '';
            nudge.hidden = false;
            nudge.setAttribute('data-done', 'true');
          } else {
            nudge.hidden = true;
          }
        }
      }

      tiers.forEach(function (t) {
        var trigger = t.matches('button') ? t : $('[data-tier-select]', t);
        if (trigger) trigger.addEventListener('click', function () { selected = parseInt(t.getAttribute('data-tier'), 10); render(); });
        $$('select[data-pick]', slotsOf(t)).forEach(function (s) {
          if (s.getAttribute('data-default')) s.value = s.getAttribute('data-default');
          if (!s.value) s.selectedIndex = 0;
          s.addEventListener('change', render);
          s.addEventListener('click', function (e) { e.stopPropagation(); });
        });
      });
      var nudge = $('[data-nudge]', box);
      if (nudge) nudge.addEventListener('click', function () { if (selected < 3) { selected += 1; render(); } });

      $$('[data-cta]', box).forEach(function (cta) {
        cta.addEventListener('click', function () {
          var r = calc(tiers[selected - 1]); var map = {}, order = [];
          r.items.forEach(function (i) { if (!i.id) return; if (!map[i.id]) { map[i.id] = 0; order.push(i.id); } map[i.id] += 1; });
          var items = order.map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
          var label = $('[data-cta-label]', cta) || cta;
          var original = label.textContent;
          var err = $('[data-error]', box);
          cta.disabled = true; label.textContent = S.adding || '…'; if (err) err.hidden = true;
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
            .then(function () { window.location.href = E.cartUrl || root + 'cart'; })
            .catch(function () {
              cta.disabled = false; label.textContent = original;
              if (err) { err.textContent = S.addError || 'Error'; err.hidden = false; }
            });
        });
      });

      selected = Math.min(tiers.length, Math.max(1, selected));
      render();
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var slides = $$('[data-slide]', g), thumbs = $$('[data-thumb]', g);
      thumbs.forEach(function (th, i) {
        th.addEventListener('click', function () {
          slides.forEach(function (s, j) {
            s.classList.toggle('is-active', i === j);
            var v = $('video', s); if (v && i !== j) v.pause();
          });
          thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(i === j)); });
        });
      });
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    var bar = $('[data-sticky-atc]'), target = $('[data-main-atc]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var below = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !e.isIntersecting && below);
        bar.setAttribute('aria-hidden', String(!(!e.isIntersecting && below)));
      });
    });
    io.observe(target);
    var btn = $('[data-sticky-btn]', bar);
    if (btn) btn.addEventListener('click', function () { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  }

  /* ---------- UGC videos ---------- */
  function initUgc() {
    $$('[data-ugc]').forEach(function (tile) {
      var v = $('video', tile);
      if (!v) return;
      tile.addEventListener('click', function () {
        if (v.paused) {
          $$('[data-ugc] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-ugc]').classList.remove('is-playing'); } });
          v.muted = false; v.play(); tile.classList.add('is-playing');
        } else { v.pause(); tile.classList.remove('is-playing'); }
      });
    });
  }

  /* ---------- Cart page quantity buttons ---------- */
  function initCart() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      $$('[data-step]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 0;
          input.value = Math.max(0, v + parseInt(b.getAttribute('data-step'), 10));
          var form = wrap.closest('form'); if (form) form.submit();
        });
      });
      input.addEventListener('change', function () { var form = wrap.closest('form'); if (form) form.submit(); });
    });
  }

  /* ---------- Welcome popup (ported from Octo Ash) ---------- */
  function initPopup() {
    var overlay = $('[data-popup]');
    if (!overlay) return;
    var SEEN = 'elafia_welcome_seen', DONE = 'elafia_welcome_subscribed';
    var COOLDOWN = (parseInt(overlay.getAttribute('data-cooldown'), 10) || 3) * 86400000;
    var reshows = 1, lastFocus = null;
    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function done() { return get(DONE) === '1'; }
    function recent() { var t = parseInt(get(SEEN), 10); return t && (Date.now() - t) < COOLDOWN; }
    function open(force) {
      if (overlay.classList.contains('is-open') || done()) return;
      if (!force && recent()) return;
      lastFocus = document.activeElement;
      overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false');
      var f = $('[data-popup-email]', overlay); if (f) setTimeout(function () { f.focus(); }, 50);
      document.removeEventListener('click', onCartClick, true);
    }
    function close() {
      overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      if (done()) return;
      set(SEEN, String(Date.now()));
      if (reshows > 0) { reshows--; setTimeout(function () { open(true); }, 5000); }
    }
    function onCartClick(e) {
      var t = e.target.closest && e.target.closest('[data-cart-icon], a[href$="/cart"], [data-open-cart]');
      if (t && !done() && !recent()) { e.preventDefault(); var href = t.getAttribute('href'); open(false); overlay.__next = href; }
    }
    $$('[data-popup-close]', overlay).forEach(function (b) {
      b.addEventListener('click', function () {
        close();
        if (overlay.__next && !done()) { var n = overlay.__next; overlay.__next = null; window.location.href = n; }
      });
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });
    if (!done() && !recent()) document.addEventListener('click', onCartClick, true);

    var form = $('[data-popup-form]', overlay);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = ($('[data-popup-email]', form).value || '').trim();
      var err = $('[data-popup-error]', form), btn = $('[data-popup-submit]', form);
      err.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = S.emailInvalid || 'Invalid email'; err.hidden = false; return; }
      btn.disabled = true;
      fetch(form.getAttribute('action') || window.location.pathname, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
        .then(finish, finish);
      function finish() { set(DONE, '1'); overlay.classList.add('is-success'); overlay.__next = null; }
    });
  }

  function init() { initSearch(); initRanges(); initBundles(); initGallery(); initSticky(); initUgc(); initCart(); initPopup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
